import React from 'react';

class AdminVendors extends React.PureComponent {
  render() {
    return <div>AdminVendors</div>;
  }
}

export default AdminVendors;
